import script from "./AnswersPc.vue?vue&type=script&setup=true&lang=js"
export * from "./AnswersPc.vue?vue&type=script&setup=true&lang=js"

import "./AnswersPc.vue?vue&type=style&index=0&id=be19ce26&lang=css"
import "./AnswersPc.vue?vue&type=style&index=1&id=be19ce26&lang=css"
import "./AnswersPc.vue?vue&type=style&index=2&id=be19ce26&lang=scss&scoped=true"

import exportComponent from "D:\\psy\\项目\\guofang\\oldgfzs\\home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be19ce26"]])

export default __exports__